import { ServerPortal } from 'pisces/helpers/portal';
import React, { Fragment, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  Route,
  RouteProps,
  Switch,
  useHistory,
  useLocation,
} from 'react-router-dom';

import { reset } from '../../actions/prismic';
import { SSRComponent } from '../../types/component';

const isPopOverRoute = (routeId?: string): boolean =>
  !!(routeId && routeId.match(/__/));

const useScrollMemory = (): void => {
  const history = useHistory();

  useEffect(() => {
    if (history.action !== 'POP') {
      window.scrollTo(0, 0);
    }
  }, [history.action, history.location.pathname]);
};

const useResetGlobalError = (): void => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(reset());
  }, [dispatch, location.pathname]);
};

const MainLayout: SSRComponent<MainLayoutProps> = ({ routes }) => {
  useScrollMemory();
  useResetGlobalError();

  return (
    <Fragment>
      <Switch>
        {routes.map(
          ({ path, id, exact, component }, idx) =>
            !isPopOverRoute(id) && (
              <Route
                key={idx}
                path={path}
                exact={exact}
                component={component}
              />
            )
        )}
      </Switch>

      <Switch>
        {routes.map(
          ({ path, id, exact, component }, idx) =>
            isPopOverRoute(id) && (
              <Route
                key={idx}
                path={path}
                exact={exact}
                component={component}
              />
            )
        )}
      </Switch>

      <ServerPortal />
    </Fragment>
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
MainLayout.getInitialProps = (data): any => {
  return data;
};

type RouteWithIdProps = { id: string } & RouteProps;

interface MainLayoutProps {
  routes: RouteWithIdProps[];
}

export default MainLayout;
